export default __webpack_public_path__ + "static/media/Hinges.a2fa1237.jpg";